/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import {
  PharmacyDailyOnlineCounselingSlot,
  PharmacyDailyOnlineCounselingSlotFromJSON,
  PharmacyDailyOnlineCounselingSlotFromJSONTyped,
  PharmacyDailyOnlineCounselingSlotToJSON,
} from "./";

export const PharmacyDailyOnlineCounselingSlotsTypename = "PharmacyDailyOnlineCounselingSlots" as const;

/**
 *
 * @export
 * @interface PharmacyDailyOnlineCounselingSlots
 */
export interface PharmacyDailyOnlineCounselingSlots {
  /**
   *
   * @type {Array<PharmacyDailyOnlineCounselingSlot>}
   * @memberof PharmacyDailyOnlineCounselingSlots
   */
  dailyOnlineCounselingSlots: Array<PharmacyDailyOnlineCounselingSlot>;
  /**
   *
   * @type {number}
   * @memberof PharmacyDailyOnlineCounselingSlots
   */
  pharmacyId: number;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyDailyOnlineCounselingSlots
   */
  readonly __typename?: string;
}

export function PharmacyDailyOnlineCounselingSlotsFromJSON(json: any): PharmacyDailyOnlineCounselingSlots {
  return PharmacyDailyOnlineCounselingSlotsFromJSONTyped(json, false);
}

export function PharmacyDailyOnlineCounselingSlotsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyDailyOnlineCounselingSlots {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyDailyOnlineCounselingSlotsTypename,

    dailyOnlineCounselingSlots: (json["daily_online_counseling_slots"] as Array<any>).map(
      PharmacyDailyOnlineCounselingSlotFromJSON
    ),
    pharmacyId: json["pharmacy_id"],
  };
}

export function PharmacyDailyOnlineCounselingSlotsToJSON(object?: PharmacyDailyOnlineCounselingSlots | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    daily_online_counseling_slots: (value.dailyOnlineCounselingSlots as Array<any>).map(
      PharmacyDailyOnlineCounselingSlotToJSON
    ),
    pharmacy_id: value.pharmacyId,
  };
}
